// @ts-nocheck
import React from "react";
import {useQuery} from "react-query";
import genRequest from "includes/request";
import PageLoad from "components/PageLoad/PageLoad";
import { t } from "i18next";

export default function FormFetcher(props) {
	const {formId} = props;
	let Form = null;

	const fetchForm = () => genRequest("forms/" + formId + "/full" + (props.withAnswers ? "?answers=true" : ""));

	function fetch() {
		Form = null;
		let prom = new Promise((resolve, reject) => {
			function handleResolve(value) {
				resolve (value);
				return (value);
			}

			function handleReject(value) {
				reject (value);
				return (false);
			}

			fetchForm()
				.then((resp) => {
					if (!resp)
						return (handleReject(false));
					Form = treat_datas(resp);
					handleResolve (Form);
				}, handleReject);
		});
		return (prom);
	}

	function treat_datas(form) {
		let ret = form.form;

		if (!ret)
			return (false);
		if (form.sections?.length)
			ret.sections = form.sections.map(sec => {
				if (form.questions?.length)
					sec.questions = form.questions.map((quest) => {
						if (quest.formSectionId === sec.formSectionId)
						{
							if (form.questionOptions?.length)
								quest.options = form.questionOptions
									.filter((opt) => {
										if (opt.questionId === quest.questionId)
											return (opt);
										return (false);
									})
									.sort((a, b) => (a.position < b.position ? -1 : 1));
							if (props.withAnswers)
							{
								if (form.answers)
								{
									quest.answers = form.answers
										.filter((ans) => {
											if (ans.questionId === quest.questionId)
												return (ans);
											return (false);
										})
										.sort((a, b) => (a.lastChanged < b.lastChanged ? -1 : 1));
								}
								else
									quest.answers = [];
							}
						}
						return (quest.formSectionId === sec.formSectionId ? quest : false);
					}).filter(a => a).sort((a, b) => (a.position < b.position ? -1 : 1));
				else
					sec.questions = [];
				return (sec);
			});
		else
			ret.sections = [];
		ret.questions = form.questions.sort((a, b) => (a.position < b.position ? -1 : 1));

		if (form.answers)
		{
			let users = [];

			form.answers.forEach((ans) => {
				let user = users.find((user => user.employeeId === ans.employeeId));
				if (user)
					user.answers.push(ans);
				else
					users.push({
						employeeId: ans.employeeId,
						answers: [ans]
					});
			});
			ret.answers = users;
		}
		return (ret);
	}

	const {isLoading, isFetching, data} = useQuery(
		["FormFetcher", "Forms", formId],
		fetch,
		{
			enabled: (formId ? true : false),
			// staleTime: 0,
			refetchOnWindowFocus: false
		}
	);

	if (isLoading || isFetching)
		return ( <PageLoad text={t("Forms.LOADING_FORM")}/> );

	return (props.children(data));
}
